<template>
<div class="AssignPermission">
  <div class="content flex-jc-bt">
    <div class="left-side flex-42">
      <sp-card type="none">
        <div class="card-content sp-color-bg-4">
          <div>
            <div v-triangle class="fw-bold text-left action-title">{{ $l('ActionPermission') }}</div>
            <div class="tips opacity tips-pd text-left">{{ $l('ActionPermissionTip') }}</div>
          </div>
          <div class="pd-l-40">
            <div class="text-left">{{ $l('Delete') }}</div>
            <sp-radio-group v-model="BasicInfo.position" class="option">
              <div class="flex-jc-bt delete">
                <div class="text-left flex-205">
                  <sp-radio label-position="right" value="NotApproved">
                    <div class="opacity">{{ $l('NotApproved') }}</div>
                  </sp-radio>
                </div>
                <div class="text-left flex-70">
                  <sp-radio label-position="right" value="Approved">
                    <div class="opacity">{{ $l('Approved') }}</div>
                  </sp-radio>
                </div>
              </div>
            </sp-radio-group>
          </div>
          <div class="text-left mg-b-20 box-border">
            <sp-icon :width="411" :height="229" type="permission-deleted" />
          </div>
          <div class="pd-l-40 mg-t-30">
            <div class="text-left">{{ $l('PostPublish') }}</div>
            <sp-radio-group v-model="BasicInfo.position" class="option">
              <div class="flex-jc-bt delete">
                <div class="text-left flex-205">
                  <sp-radio label-position="right" value="Approved">
                    <div class="opacity">{{ $l('Approved') }}</div>
                  </sp-radio>
                </div>
                <div class="text-left flex-70">
                  <sp-radio label-position="right" value="NotApproved">
                    <div class="opacity">{{ $l('NotApproved') }}</div>
                  </sp-radio>
                </div>
              </div>
            </sp-radio-group>
          </div>
          <div class="text-left mg-b-20 box-border">
            <sp-icon :width="411" :height="229" type="permission-selected" />
          </div>
          <div class="additional">
            <div class="text-left pd-b-10">{{ $l('Additional') }}</div>
            <sp-input type="warn2"  text-type="textArea" row="5" />
          </div>
        </div>
      </sp-card>
    </div>
    <div class="right-side sp-color-bg-4 flex-56">
      <SpTableDIY :data-list="dataList">
        <SpTableColumn column-name="MyName" label="MyName">
          <template #default="row">
            <div>{{ row.MyName }}</div>
            <div class="attach">
              {{ row.MyName2 }}
            </div>
          </template>
        </SpTableColumn>
        <SpTableColumn column-name="DeptAccessIdentity" label="DeptAccessIdentity" />
        <SpTableColumn column-name="Responsibilities" label="Responsibilities" />
        <SpTableColumn column-name="Position" label="Position" />
        <SpTableColumn column-name="JobDescription" label="JobDescription" />
      </SpTableDIY>
      <div class="pd-t-40">
        <div v-triangle class="text-left">{{ $l('CoverPagePermission') }}</div>
        <sp-radio-group v-model="BasicInfo.position" class="option">
          <div class="text-left pd-t-20">
            <sp-radio label-position="right" value="AllPages">
              <div>{{ $l('AllPages') }}</div>
            </sp-radio>
          </div>
          <div class="text-left mg-b-10 pd-t-20">
            <sp-radio label-position="right" value="DesignatedPage">
              <div>{{ $l('DesignatedPage') }}</div>
            </sp-radio>
          </div>
          <sp-tag-group v-model="type" class="tags pd-t-20">
              <sp-tag class="tags-font" label="PublishingCenter">{{ $l('PublishingCenter') }}</sp-tag>
              <sp-tag class="tags-font" label="MatchingResults">{{ $l('MatchingResults') }}</sp-tag>
              <sp-tag class="tags-font" label="CompaniesStaffControl">{{ $l('CompaniesStaffControl') }}</sp-tag>
              <sp-tag class="tags-font" label="SharingContributions">{{ $l('SharingContributions') }}</sp-tag>
              <sp-tag class="tags-font" label="ReceivingCenter">{{ $l('ReceivingCenter') }}</sp-tag>
          </sp-tag-group>
          <div>
            <!-- 关于船 -->
            <div class="mg-t-20">
                <div class="pd-t-30 text-left">
                    <sp-radio label-position="right" value="AboutShips">
                        <div class="fw-bold">{{ $l('AboutShips') }}</div>
                    </sp-radio>
                </div>
                <div class="text-left mg-t-20">
                    <!-- My Favorite Tonnages -->
                    <div class="flex-jc-bt flex-al-center">
                        <div class="flex-20">
                            <sp-radio label-position="right" value="MyFavoriteTonnages">
                                <div>{{ $l('MyFavoriteTonnages') }}</div>
                            </sp-radio>
                        </div>
                        <div class="flex-65 flex-jc-bt">
                            <div class="flex-30">
                                <sp-radio class="mg-b-10" label-position="right" value="EditRight">
                                    <div class="opacity">{{ $l('EditRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="CollectionRight">
                                    <div class="opacity">{{ $l('CollectionRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="RightToBrowse">
                                    <div class="opacity">{{ $l('RightToBrowse') }}</div>
                                </sp-radio>
                            </div>
                            <div class="flex-65">
                                <div class="flex-jc-bt">
                                    <sp-radio class="mg-b-10 flex-40" label-position="right" value="DeleteRight">
                                        <div class="opacity">{{ $l('DeleteRight') }}</div>
                                    </sp-radio>
                                    <sp-radio class="mg-b-10 flex-50" label-position="right" value="AddRight">
                                        <div class="opacity">{{ $l('AddRight') }}</div>
                                    </sp-radio>
                                </div>
                                <sp-radio class="mg-b-10" label-position="right" value="AddCollectionAfter">
                                    <div class="opacity">{{ $l('AddCollectionAfter') }}</div>
                                </sp-radio>
                            </div>
                        </div>
                    </div>
                    <!-- Companies Definition -->
                    <div class="flex-jc-bt mg-t-20 flex-al-center">
                        <div class="flex-20">
                            <sp-radio label-position="right" value="CompaniesDefinition">
                                <div>{{ $l('CompaniesDefinition') }}</div>
                            </sp-radio>
                        </div>
                        <div class="flex-65 flex-jc-bt">
                            <div class="flex-30">
                                <sp-radio class="mg-b-10" label-position="right" value="EditRight">
                                    <div class="opacity">{{ $l('EditRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="CollectionRight">
                                    <div class="opacity">{{ $l('CollectionRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="RightToBrowse">
                                    <div class="opacity">{{ $l('RightToBrowse') }}</div>
                                </sp-radio>
                            </div>
                            <div class="flex-65">
                                <div class="flex-jc-bt">
                                    <sp-radio class="mg-b-10 flex-40" label-position="right" value="DeleteRight">
                                        <div class="opacity">{{ $l('DeleteRight') }}</div>
                                    </sp-radio>
                                    <sp-radio class="mg-b-10 flex-50" label-position="right" value="AddRight">
                                        <div class="opacity">{{ $l('AddRight') }}</div>
                                    </sp-radio>
                                </div>
                                <sp-radio class="mg-b-20" label-position="right" value="AddCollectionAfter">
                                    <div class="opacity">{{ $l('AddCollectionAfter') }}</div>
                                </sp-radio>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 关于货 -->
            <div class="mg-t-20">
                <div class="pd-t-30 text-left">
                    <sp-radio label-position="right" value="AboutCargos">
                        <div class="fw-bold">{{ $l('AboutCargos') }}</div>
                    </sp-radio>
                </div>
                <div class="text-left mg-t-20">
                    <!-- My Favorite Tonnages -->
                    <div class="flex-jc-bt flex-al-center">
                        <div class="flex-20">
                            <sp-radio label-position="right" value="MyFavoriteCargos">
                                <div>{{ $l('MyFavoriteCargos') }}</div>
                            </sp-radio>
                        </div>
                        <div class="flex-65 flex-jc-bt">
                            <div class="flex-30">
                                <sp-radio class="mg-b-10" label-position="right" value="EditRight">
                                    <div class="opacity">{{ $l('EditRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="CollectionRight">
                                    <div class="opacity">{{ $l('CollectionRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="RightToBrowse">
                                    <div class="opacity">{{ $l('RightToBrowse') }}</div>
                                </sp-radio>
                            </div>
                            <div class="flex-65">
                                <div class="flex-jc-bt">
                                    <sp-radio class="mg-b-10 flex-40" label-position="right" value="DeleteRight">
                                        <div class="opacity">{{ $l('DeleteRight') }}</div>
                                    </sp-radio>
                                    <sp-radio class="mg-b-10 flex-50" label-position="right" value="AddRight">
                                        <div class="opacity">{{ $l('AddRight') }}</div>
                                    </sp-radio>
                                </div>
                                <sp-radio class="mg-b-20" label-position="right" value="AddCollectionAfter">
                                    <div class="opacity">{{ $l('AddCollectionAfter') }}</div>
                                </sp-radio>
                            </div>
                        </div>
                    </div>
                    <!-- Companies Definition -->
                    <div class="flex-jc-bt mg-t-20 flex-al-center">
                        <div class="flex-20">
                            <sp-radio label-position="right" value="CompaniesDefinition">
                                <div>{{ $l('CompaniesDefinition') }}</div>
                            </sp-radio>
                        </div>
                        <div class="flex-65 flex-jc-bt">
                            <div class="flex-30">
                                <sp-radio class="mg-b-10" label-position="right" value="EditRight">
                                    <div class="opacity">{{ $l('EditRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="CollectionRight">
                                    <div class="opacity">{{ $l('CollectionRight') }}</div>
                                </sp-radio>
                                <sp-radio class="mg-b-10" label-position="right" value="RightToBrowse">
                                    <div class="opacity">{{ $l('RightToBrowse') }}</div>
                                </sp-radio>
                            </div>
                            <div class="flex-65">
                                <div class="flex-jc-bt">
                                    <sp-radio class="mg-b-10 flex-40" label-position="right" value="DeleteRight">
                                        <div class="opacity">{{ $l('DeleteRight') }}</div>
                                    </sp-radio>
                                    <sp-radio class="mg-b-10 flex-50" label-position="right" value="AddRight">
                                        <div class="opacity">{{ $l('AddRight') }}</div>
                                    </sp-radio>
                                </div>
                                <sp-radio class="mg-b-20" label-position="right" value="AddCollectionAfter">
                                    <div class="opacity">{{ $l('AddCollectionAfter') }}</div>
                                </sp-radio>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </sp-radio-group>
      </div>
    </div>
  </div>
  <div class="buttons">
    <sp-button class="mg-t-40" circleRadius="4" type="primary" :label="$l('Submit')" :bold="-1" :width="333" :height="101" />
    <sp-button class="mg-t-60 mg-b-50" circleRadius="4" type="back" :label="$L('back')" :bold="-1" :width="333" :height="101" />
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import spCard from '@/components/common/SpCard'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import spIcon from '@/components/common/SpIcon'
import spInput from '@/components/common/SpInput'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import spButton from '@/components/common/SpButton'
export default {
  name: 'assignPermisssions',
  nameSpace: 'company.AssignPermissions',
  components: {
    spCard,
    spRadio,
    spRadioGroup,
    spIcon,
    spInput,
    SpTableDIY,
    SpTableColumn,
    spTag,
    spTagGroup,
    spButton
  },
  data () {
    return {
      type: 'PublishingCenter',
      BasicInfo: {
        position: {}
      },
      dataList: [{
        MyName: 'Lora',
        MyName2: '张',
        DeptAccessIdentity: 'Shipowners',
        Responsibilities: 'Chartering',
        Position: 'PIC',
        JobDescription: 'joinocean'
      }]
    }
  },
  computed: {},
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang="less">
.AssignPermission {
  .opacity {
    opacity: .7;
  }
  .content {
    padding: @gap*1.5 @gap*2 @gap @gap*2;
    .left-side {
      .action-title {
        padding: @gap*1.5 @gap*2.5 0 @gap*1.5;
      }
      .tips {
        font-size: 14px;
      }
      .tips-pd {
        word-spacing: 1px;
        padding: 0 @gap*2 @gap @gap*2.5;
      }
      .delete{
        padding: 15px 0 @gap*1.5 0;
      }
      .box-border {
        // box-sizing: border-box;
        margin-left: @gap*2;
        max-width: 411px;
        max-height: 229px;
        border: 1px dashed #666;
      }
      .additional {
        padding: @gap @gap*8 @gap*2 @gap*2;
      }
    }
    .right-side {
      box-sizing: border-box;
      padding: @gap*3.5 @gap/2 @gap*4 @gap*2;
      .attach{
        color: #676767;
        font-size: 14px;
      }
      .tags-font {
        font-size: 14px;
      }
    }
  }
  .buttons {
    padding: @gap*2 @gap*2 @gap*2 @gap*5;
  }
}
</style>
